<template>
  <div class="wf">
    <div class="wf-panel">
      <div class="wf-panel__h">
        <div class="wf-panel__title">提现手续费配置</div>
        <el-button type="primary" class="wf-btn-add" @click="openAdd">
          <img :src="sliceM('add.png')" class="wf-btn-add-ico" alt="" role="presentation" />
          <span>新增配置</span>
        </el-button>
      </div>

      <el-table v-loading="loading" :data="rawRows" class="wf-table" size="small" style="width: 100%">
        <el-table-column label="币种" width="120">
          <template slot-scope="s">
            <span class="wf-coin">{{ (s.row.coin || '').toUpperCase() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="链 / 网络" min-width="140">
          <template slot-scope="s">
            <span class="wf-chain">{{ s.row.chain || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手续费（与币种同单位）" min-width="200">
          <template slot-scope="s">
            <span class="wf-fee">{{ formatFee(s.row.fee) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="160">
          <template slot-scope="s">
            <span class="cell-muted">{{ fmtTime(s.row.updated_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="s">
            <div class="wf-act-row">
              <button type="button" class="wf-act" title="编辑" @click="openEdit(s.row)">
                <img :src="sliceM('edit.png')" alt="编辑" />
              </button>
              <el-button type="text" size="small" class="wf-del" @click="confirmDelete(s.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增 -->
    <el-dialog
      :visible.sync="dlgAdd"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view wdl--merchant-add"
      :close-on-click-modal="false"
      :show-close="false"
      @closed="resetAdd"
    >
      <div class="wdl-hero wdl-hero--sm wdl-hero--mc wdl-hero--add" :style="modalBg">
        <div class="wdl-hero__stack wdl-hero__stack--add">
          <img :src="sliceM('add_modal.png')" class="wdl-hero-add-ico" alt="" role="presentation" />
          <div class="wdl-hero-txt wdl-hero-txt--add">新增手续费</div>
        </div>
        <button type="button" class="wdl-x wdl-x--round" @click="dlgAdd = false">
          <img :src="sliceCloseModal()" alt="关闭" />
        </button>
      </div>
      <div class="mc-add-body">
        <el-form ref="addFormRef" :model="addForm" :rules="formRules" label-position="top" size="small" class="mc-add-form">
          <el-form-item label="币种" prop="coin" class="mc-add-item">
            <el-input v-model="addForm.coin" clearable placeholder="如 USDT、BTC、ETH" class="mc-add-inp" />
          </el-form-item>
          <el-form-item label="链 / 网络" prop="chain" class="mc-add-item">
            <el-input v-model="addForm.chain" clearable placeholder="如 TRC20、ERC20、Native" class="mc-add-inp" />
          </el-form-item>
          <el-form-item label="手续费" prop="fee" class="mc-add-item">
            <el-input v-model="addForm.fee" clearable placeholder="≥ 0，与币种同单位" class="mc-add-inp" />
          </el-form-item>
        </el-form>
        <div class="mc-view-foot mc-add-foot">
          <el-button class="mc-view-foot__back" @click="dlgAdd = false">取消返回</el-button>
          <el-button type="primary" class="mc-view-foot__edit" :loading="addLoading" @click="submitAdd">立即保存</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      :visible.sync="dlgEdit"
      width="600px"
      custom-class="wdl-dialog wdl--merchant-view wdl--merchant-add"
      :close-on-click-modal="false"
      :show-close="false"
      @open="onEditOpen"
    >
      <div v-if="editForm">
        <div class="wdl-hero wdl-hero--sm wdl-hero--mc" :style="modalBg">
          <div class="wdl-hero__stack">
            <div class="wdl-hero-txt">编辑手续费</div>
          </div>
          <button type="button" class="wdl-x wdl-x--round" @click="dlgEdit = false">
            <img :src="sliceCloseModal()" alt="关闭" />
          </button>
        </div>
        <div class="mc-add-body">
          <el-form ref="editFormRef" :model="editForm" :rules="formRules" label-position="top" size="small" class="mc-add-form">
            <el-form-item label="币种" prop="coin" class="mc-add-item">
              <el-input v-model="editForm.coin" clearable class="mc-add-inp" />
            </el-form-item>
            <el-form-item label="链 / 网络" prop="chain" class="mc-add-item">
              <el-input v-model="editForm.chain" clearable class="mc-add-inp" />
            </el-form-item>
            <el-form-item label="手续费" prop="fee" class="mc-add-item">
              <el-input v-model="editForm.fee" clearable class="mc-add-inp" />
            </el-form-item>
          </el-form>
          <div class="mc-view-foot mc-add-foot">
            <el-button class="mc-view-foot__back" @click="dlgEdit = false">取消返回</el-button>
            <el-button type="primary" class="mc-view-foot__edit" :loading="editLoading" @click="submitEdit">立即保存</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi } from '@/api/admin'

export default {
  name: 'AdminWithdrawFeeView',
  data() {
    return {
      loading: false,
      rawRows: [],
      dlgAdd: false,
      addLoading: false,
      addForm: { coin: '', chain: '', fee: '' },
      dlgEdit: false,
      editLoading: false,
      editForm: null,
      formRules: {
        coin: [{ required: true, message: '请输入币种', trigger: 'blur' }],
        chain: [{ required: true, message: '请输入链 / 网络', trigger: 'blur' }],
        fee: [
          { required: true, message: '请输入手续费', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              const s = (value || '').toString().trim()
              if (s === '') {
                callback(new Error('请输入手续费'))
                return
              }
              const x = parseFloat(s)
              if (Number.isNaN(x) || x < 0) {
                callback(new Error('手续费须为 ≥ 0 的数字'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    modalBg() {
      return {
        backgroundImage: `url('${this.sliceAddr('modal_bg.png')}')`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top'
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceW(n) {
      return this.base() + 'slices/withdraw/' + encodeURIComponent(n)
    },
    sliceM(n) {
      return this.base() + 'slices/merchant/' + encodeURIComponent(n)
    },
    sliceAddr(n) {
      return this.base() + 'slices/withdraw/address/' + encodeURIComponent(n)
    },
    sliceCloseModal() {
      return this.base() + 'slices/' + encodeURIComponent('close_modal.png')
    },
    formatFee(v) {
      const x = parseFloat(v)
      if (Number.isNaN(x)) return '—'
      return x.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })
    },
    fmtTime(t) {
      if (!t) return '—'
      return String(t).replace('T', ' ').slice(0, 19)
    },
    async load() {
      this.loading = true
      try {
        const r = await adminApi.withdrawFeeConfigs()
        const list = r.data || []
        this.rawRows = Array.isArray(list) ? list : []
      } catch (e) {
        this.rawRows = []
      } finally {
        this.loading = false
      }
    },
    openAdd() {
      this.dlgAdd = true
    },
    resetAdd() {
      this.addForm = { coin: '', chain: '', fee: '' }
      this.$nextTick(() => this.$refs.addFormRef && this.$refs.addFormRef.clearValidate())
    },
    submitAdd() {
      this.$refs.addFormRef.validate(async (ok) => {
        if (!ok) return
        this.addLoading = true
        try {
          await adminApi.withdrawFeeSave({
            coin: String(this.addForm.coin).trim().toUpperCase(),
            chain: String(this.addForm.chain).trim(),
            fee: String(this.addForm.fee).trim()
          })
          this.$message.success('已保存')
          this.dlgAdd = false
          this.load()
        } catch (e) {
          /* 已弹 */
        } finally {
          this.addLoading = false
        }
      })
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        coin: (row.coin || '').toUpperCase(),
        chain: row.chain || '',
        fee: row.fee != null ? String(row.fee) : ''
      }
      this.dlgEdit = true
    },
    onEditOpen() {
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate())
    },
    submitEdit() {
      if (!this.editForm) return
      this.$refs.editFormRef.validate(async (ok) => {
        if (!ok) return
        this.editLoading = true
        try {
          await adminApi.withdrawFeeSave({
            id: this.editForm.id,
            coin: String(this.editForm.coin).trim().toUpperCase(),
            chain: String(this.editForm.chain).trim(),
            fee: String(this.editForm.fee).trim()
          })
          this.$message.success('已保存')
          this.dlgEdit = false
          this.load()
        } catch (e) {
          /* */
        } finally {
          this.editLoading = false
        }
      })
    },
    confirmDelete(row) {
      this.$confirm('确定删除该手续费配置？', '提示', { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' })
        .then(async () => {
          try {
            await adminApi.withdrawFeeDelete(row.id)
            this.$message.success('已删除')
            this.load()
          } catch (e) {
            /* */
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.wf {
  max-width: 100%;
}
.wf-panel {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  padding: 16px 18px 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}
.wf-panel__h {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}
.wf-panel__title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}
.wf-btn-add {
  height: 40px !important;
  padding: 0 18px !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  font-weight: 600;
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
}
.wf-btn-add-ico {
  width: 10px;
  height: 10px;
  object-fit: contain;
}
.wf-coin {
  font-weight: 700;
  color: #0f172a;
}
.wf-chain {
  font-weight: 600;
  color: #334155;
}
.wf-fee {
  font-weight: 600;
  color: #2563eb;
  font-variant-numeric: tabular-nums;
}
.wf-act-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.wf-act {
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  border-radius: 8px;
  img {
    width: 33px;
    height: 33px;
    object-fit: contain;
  }
}
.wf-del {
  color: #dc2626 !important;
  font-weight: 600;
  padding: 0 4px !important;
}
.cell-muted {
  color: #94a3b8;
  font-size: 13px;
}
.mc-add-body {
  padding: 24px 32px 28px;
  background: #fff;
  box-sizing: border-box;
}
.mc-add-form {
  ::v-deep .el-form-item__label {
    color: #94a3b8;
    font-size: 13px;
    font-weight: 500;
    padding-bottom: 8px;
    line-height: 1.35;
  }
}
.mc-add-item {
  margin-bottom: 18px;
}
.mc-add-inp {
  width: 100%;
  ::v-deep .el-input__inner {
    height: 44px;
    line-height: 44px;
    border-radius: 12px;
    border-color: #e2e8f0;
    font-size: 14px;
  }
}
.mc-add-foot {
  margin-top: 12px;
  padding-top: 4px;
}
.mc-view-foot {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  gap: 12px;
  margin-top: 4px;
  padding-top: 4px;
}
.mc-view-foot .mc-view-foot__back,
.mc-view-foot .mc-view-foot__edit {
  flex: 1 1 0;
  min-width: 0;
  margin: 0 !important;
}
.mc-view-foot__back {
  min-width: 120px;
  height: 44px !important;
  padding: 0 20px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 500;
  color: #64748b !important;
  background: #f1f5f9 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  &:hover {
    background: #e8eef5 !important;
  }
}
.mc-view-foot__edit {
  min-width: 120px;
  height: 44px !important;
  padding: 0 24px !important;
  line-height: 44px !important;
  font-size: 15px;
  font-weight: 600;
  border: none !important;
  border-radius: 14px !important;
  color: #fff !important;
  background: linear-gradient(221deg, #0850f0 0%, #155dfc 7.39%, #00b7ff 100%) !important;
  box-shadow: 0 2px 4px -2px rgba(43, 127, 255, 0.2), 0 4px 6px -1px rgba(43, 127, 255, 0.2);
  &:hover,
  &:focus {
    background: linear-gradient(221deg, #0646d4 0%, #0e4bdc 7.39%, #00a3e0 100%) !important;
  }
}
</style>

<style lang="scss">
/* 与商户/提现：弹窗标头、关闭 */
.wdl-dialog.wdl--merchant-view {
  border-radius: 28px;
  overflow: hidden;
  margin-top: 5vh !important;
}
.wdl-dialog.wdl--merchant-view .el-dialog__header,
.wdl-dialog.wdl--merchant-view .el-dialog__body {
  padding: 0;
}
.wdl-dialog.wdl--merchant-view .el-dialog__headerbtn {
  display: none;
}
.wdl-hero--mc {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 72px;
  box-sizing: border-box;
  padding: 18px 68px 18px 24px;
  border-radius: 0;
}
.wdl-hero--add .wdl-hero__stack--add {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.wdl-hero--add .wdl-hero-add-ico {
  display: block;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  object-fit: contain;
  flex-shrink: 0;
}
.wdl-hero__stack {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.wdl-hero--mc .wdl-hero__stack .wdl-hero-txt {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wdl-hero--mc .wdl-x {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  width: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  box-sizing: border-box;
  cursor: pointer;
  line-height: 0;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  &.wdl-x--round {
    border-radius: 50%;
    background: #fff;
    border: none;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
  }
}
</style>
